enum QuestionType {
  Radio = 'Radio',
  File = 'File',
  Text = 'Text',
  Dropdown = 'Dropdown',
  Checkbox = 'Checkbox',
  SubList = 'SubList',
  Currency = 'Currency',
  Date = 'Date',
  MultilineText = 'MultilineText',
  DropdownCustomList = 'DropdownCustomList',
  Phone = 'Phone',
  Email = 'Email',
  Country = 'Country',
  State = 'State',
  ZipCode = 'ZipCode',
  Address = 'Address',
  MultiSelectDropDown = 'MultiSelectDropDown',
}
export default QuestionType;
